import React from "react";
import { useCurrenciesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const CurrencySelect = (props) => {
    const query = useCurrenciesQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}